export default "__VITE_ASSET__eeeeefd1__"